import React, { Component } from 'react';
import { Grid, Cell, portable } from 'react-flexr';
import StyleSheet from 'stilr';
import Link from '../routing/Link';

const styles = StyleSheet.create({
  wrapper: {
    marginTop: '2em',
    borderTop: '1px solid #cccccc',
    backgroundColor: '#f0f0f0',
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: 'auto',
    [portable]: {
      position: 'initial'
    }
  },
  container: {
    paddingTop: '2em',
    paddingBottom: '2em',
    marginBottom: 0
  }
});

class Footer extends Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <div className="container">
          <Grid className={styles.container}>
            <Cell size="6/12" palm="1/1" lap="5/12">
              <p>
                SparPenge.dk er en kommerciel tjeneste og modtager provision fra
                udbydere der omtales / henvises til. Lister omfatter ikke alle
                udbydere og produkter. Rækkefølge er påvirket af samarbejdet med
                udbydere. Info om produkter og tilbud indsamles fra udbyderne,
                og vi tager forbehold for fejl. Vi anvender cookies og
                registrerer adfærd jvf. privatlivspolitik og vilkår.
              </p>
            </Cell>

            <Cell size="2/12" palm="1/3" lap="2/12">
              <Link to="/a-kasse">A-kasser</Link>
              <br />
              <Link to={encodeURI('/lån')}>Lån</Link>
              <br />
              <Link to="/tv-udbydere">TV udbydere</Link>
              <br />
              <Link to={encodeURI('/måltidskasse')}>Måltidskasse</Link>
              <br />
              <Link to="/webhotel">Webhotel</Link>
              <br />
              <a href="https://www.akutbolig.dk/">Lejeboliger</a>
              <br />
            </Cell>

            <Cell size="2/12" palm="1/3" lap="2/12">
              <Link to={encodeURI('/bredbånd')}>Bredbånd</Link>
              <br />
              <Link to={encodeURI('/mobilt-bredbånd')}>Mobilt Bredbånd</Link>
              <br />
              <Link to="/mobilabonnement">Mobilabonnement</Link>
              <br />
              <Link to="/taletidskort">Taletidskort</Link>
              <br />
              <Link to="/streaming">Streaming</Link>
              <br />
              <Link to="/vpn">VPN</Link>
              <br />
            </Cell>

            <Cell size="2/12" palm="1/3" lap="3/12">
              <Link to="/om">Om SparPenge.dk</Link>
              <br />
              <Link to="/kontakt">Kontakt</Link>
              <br />
              <Link to="/privacy">Privatlivspolitik</Link>
              <br />
              <Link to="/terms">Vilkår</Link>
              <br />
            </Cell>

            <Cell size="1/1" style={{ marginTop: '1em' }}>
              © {new Date().getFullYear()}{' '}
              <a href="https://hashtag.dk/">Hashtag Media ApS</a>, CVR: 43980491 •{' '}
              <a href="mailto:kontakt@sparpenge.dk">kontakt@sparpenge.dk</a>
            </Cell>
          </Grid>
        </div>
      </div>
    );
  }
}

export default Footer;
